module.exports = __webpack_public_path__ + "static/media/riskFemale.82a4d78d.mp3";